import getOrganizationNodes from './getOrganizationNodes';
import latestReleases from '../helpers/versions/latestReleases';

export default (params) => {
  const { preTag, sectionKey } = params;

  let documentData = {
    selectAll: 0,

    /**
     * Keep updating this version number to latest or
     * if there is a specific version for a specific section overwrite in that block
     */
    version: {
      number: latestReleases[sectionKey],
      updated: true,
    },
    rolesCount: 0,
  };

  let data = {
    Ordinal: 1,
    selectAll: 0,
  };

  if (
    preTag === 'projects' ||
    preTag === 'research_experience' ||
    preTag === 'education' ||
    preTag === 'extra_curricular' ||
    preTag === 'work_experience'
  ) {
    data = {
      ...data,
      selectAll: 1,
    };

    documentData = {
      ...documentData,
      selectAll: 1,
      rolesCount: 1,
    };
  } else if (preTag === 'skill') {
    data = {
      selectAll: 1,
    };

    documentData = {
      ...documentData,
      selectAll: 1,
      rolesCount: 1,
    };
  }

  return {
    document: {
      data: documentData,
      nodes: [
        {
          object: 'block',
          type: `${preTag}_organization`,
          data,
          nodes: getOrganizationNodes(params),
        },
      ],
    },
  };
};
